import { redirectAuthenticatedFromLoginMiddleware } from "~/components/_refactored/auth";

export default redirectAuthenticatedFromLoginMiddleware;
